<script>
  import bulkJson from "../../../Stores/jsonBulkData"
  import { loadImage } from "../../../Script/bulkUpload"
  import { onMount } from "svelte"
  import { isStringifiedObject } from "../../../Script/bulkUpload"
  import { createEventDispatcher } from "svelte"
  import notify from "../../../../../../Script/notify"
  import { validateFile } from "../../../Script/bulkUpload"
  const dispatch = createEventDispatcher()

  /**
   * @type {File} file to be uploaded by the user
   */
  let files
  /**
   * @type {Array<String>} array of missing filenames
   */
  let missingFiles = []
  /**
   * @type {Array<String>} array of valid filenames
   */
  export let duplicateImageRemovedArray = []
  /**
   * @type {Array<files>} array of files uploaded by the user
   */
  let fileArray = []
  /**
   * @type {boolean} whether to disable upload btn or not
   */
  let showUploadBtn = true
  let uploadInput = null

  export let totalUploadedSubDoc = 0

  /**
   * Executes the provided function when the component is mounted.
   */
  onMount(() => {
    // Iterate through each document in $bulkJson.

    for (let i = 0; i < $bulkJson.length; i++) {
      // Parse the 'filename' property from JSON format to a JavaScript object.
      // console.log(isStringifiedObject($bulkJson[i].filename))

      if (isStringifiedObject($bulkJson[i].filename)) {
        $bulkJson[i].filename = JSON.parse($bulkJson[i].filename)
      }

      for (let i = 0; i < duplicateImageRemovedArray.length; i++) {
        if (typeof duplicateImageRemovedArray[i].image == "string") showUploadBtn = false
      }
    }
  })

  // $: uploadFiles(files)
  /**
   * Uploads files, replaces missing filenames with loaded images, and starts the generating process.
   */
  const uploadFiles = async (e) => {
    try {
      // if (files && Object.keys(files).length) {
      // console.log(e)
      // console.log(e.target)
      files = e.target.files
      // console.log(files)
      await validateFile(files[0])

      // Initialize arrays to store missing files and uploaded file data
      missingFiles = []
      fileArray = []

      // Copy the 'files' array to 'fileArray'
      fileArray = [...files]

      // Loop through each document in $bulkJson
      for (let i = 0; i < $bulkJson.length; i++) {
        for (const [key, value] of Object.entries($bulkJson[i].filename)) {
          // Check if the value is a string (indicating a missing file)
          if (typeof value == "string") {
            // Find the file with the same name in the fileArray
            let isFileFound = fileArray.filter((file) => file.name === value)

            // If a matching file is found, load its image using loadImage
            if (isFileFound.length) {
              try {
                let file = await validateFile(isFileFound[0])
                // console.log(file)
                let blobURL = URL.createObjectURL(file)
                $bulkJson[i].filename[key] = await loadImage(blobURL)

                for (let j = 0; j < duplicateImageRemovedArray.length; j++) {
                  if (duplicateImageRemovedArray[j].name == value) {
                    duplicateImageRemovedArray[j].upload = true
                    duplicateImageRemovedArray[j].image = await loadImage(blobURL)
                  }
                }
                duplicateImageRemovedArray = [...duplicateImageRemovedArray]
              } catch (error) {
                const info = "PAGE: File Generation (Bulk Upload)\nEVENT: While matching file details with the uploaded file during dynamic image upload."
                notify.danger(error, info)
              }
            }
          }
        }
      }

      // Check for any remaining missing files
      totalUploadedSubDoc = 0
      for (let i = 0; i < duplicateImageRemovedArray.length; i++) {
        if (duplicateImageRemovedArray[i].upload) totalUploadedSubDoc = totalUploadedSubDoc + 1
      }

      // If there are missing files, reset 'files' and exit the function
      checkMissingFiles()

      // if (missingFiles.length) {
      if (duplicateImageRemovedArray.length != totalUploadedSubDoc) {
        const count = duplicateImageRemovedArray.length - totalUploadedSubDoc
        notify.info(`<strong>${count} ${count > 1 ? "Files" : "File"} missed</strong>`)
        files = undefined
        return
      } else {
        // Start the generating process if no missing files are found
        showUploadBtn = true
        // dispatch("startGenerating")
      }
      // }
    } catch (error) {
      const info = "PAGE: File Generation (Bulk Upload)\nEVENT: While processing uploaded files during dynamic image upload."
      notify.danger(error, info)
    } finally {
      e.dataTransfer ? (e.dataTransfer.value = null) : (e.target.value = null)
      // showUploadBtn = false
    }
  }

  /**
   * Checks for missing files in the bulk JSON data and compiles a list of filenames.
   * Populates the 'missingFiles' array with filenames that are strings.
   */
  const checkMissingFiles = () => {
    for (let i = 0; i < $bulkJson.length; i++) {
      if (typeof $bulkJson[i].filename != "string") {
        for (const [key, value] of Object.entries($bulkJson[i].filename)) {
          // Check if the value is a string (indicating a missing file)
          if (typeof value == "string") {
            // Add the filename to the 'missingFiles' array
            missingFiles = [...missingFiles, value]
          }
        }
      }
    }
  }
</script>

<!-- <div class="flex flex-col items-center gap-3">
  <h1 class="text-xl font-bold dark:text-white">Choose all Dynamic Images</h1>
  <h1 class="text-center text-sm font-medium text-gray-200">Uploading these files to our servers is not required. Please pick all the files at once.</h1>
</div> -->

<!-- {#if files}
  <div class="relative mx-auto mt-6 flex w-full flex-col items-center justify-center gap-3 rounded-md border border-dashed border-gray-200 px-12 py-12 hover:border-gray-200/50 hover:bg-[#f7f7f7] dark:hover:bg-lightgray sm:w-1/2">
    <div class="text-3xl text-gray-200">
      <i class="fa-solid fa-file fa-xl lg:fa-2xl" />
    </div>
    <button
      on:click={() => {
        files = undefined
      }}
      class="absolute right-1 top-1 cursor-pointer text-gray-200 hover:text-red-500 active:text-red-500"
    >
      <i class="fa-solid fa-circle-xmark fa-lg" />
    </button>
    <span class="md:txet-base text-center text-sm font-medium text-gray-200">{files.length} files Uploaded</span>
  </div>
{:else} -->
<!-- <div class="relative mx-auto mt-6 flex w-full flex-col items-center justify-center gap-3 rounded-md border border-dashed border-gray-200 px-12 py-6 hover:border-gray-200/50 hover:bg-[#f7f7f7] dark:hover:bg-lightgray">
  <input bind:files multiple type="file" accept="image/*" class="absolute inset-0 cursor-pointer opacity-0" />
  <div class="text-3xl text-gray-200">
    <i class="fa-solid fa-cloud-arrow-up fa-xl lg:fa-2xl" />
  </div>
  <span class="md:txet-base text-center text-sm font-medium text-gray-200">Select a file by dragging and dropping it, or Click here to upload.</span>
  <span class="text-center text-xs font-normal text-gray-100 md:text-sm">Supported formats: jpg, jpeg, png.</span>
</div> -->
<!-- {/if} -->

<!-- {#if missingFiles.length}
  <div class="mt-6 flex w-full items-center gap-3 rounded-md bg-[#fff3cd] px-2 py-3 text-base font-medium text-[#856404]">
    <div class="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-[#856404] text-white">
      <i class="fa-solid fa-triangle-exclamation text-xl" />
    </div>
    <h1 class="wordBreak text-base font-bold">{missingFiles.toString()} are missing.</h1>
  </div>
{/if} -->

{#if showUploadBtn}
  <h1 class="text-center text-sm font-medium text-gray-200">All files have been uploaded. Click the button below to proceed with file generation.</h1>

  <div class="mt-3 flex justify-center">
    <button on:click={() => dispatch("startGenerating")} type="button" class="disabled:text-white-200/50 flex h-9 min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-4 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:bg-gray-200/50">
      <span><i class="fa-solid fa-forward" /></span>
      <span class="select-none">&nbsp;&nbsp;Continue&nbsp;to&nbsp;Generate&nbsp;File</span>
    </button>
  </div>
{:else}
  <div class="relative mx-auto mt-6 flex w-full flex-col items-center justify-center gap-3 rounded-md border border-dashed border-gray-200 px-12 py-6 hover:border-gray-200/50 hover:bg-[#f7f7f7] dark:hover:bg-lightgray">
    <input on:input={uploadFiles} multiple type="file" accept="image/*" class="absolute inset-0 cursor-pointer opacity-0" bind:this={uploadInput} />
    <div class="text-3xl text-gray-200">
      <i class="fa-solid fa-cloud-arrow-up fa-xl lg:fa-2xl" />
    </div>
    <span class="md:txet-base text-center text-sm font-medium text-gray-200">Select a file by dragging and dropping it, or Click here to upload.</span>
    <span class="text-center text-xs font-normal text-gray-100 md:text-sm">Supported formats: jpg, jpeg, png.</span>
  </div>
{/if}
